<div class="project-content-margin full-width">
  <iframe style="pointer-events: none;"
    src="https://www.openstreetmap.org/export/embed.html?bbox=12.415012121200563%2C55.6934730767669%2C12.428508996963503%2C55.69904800234419&amp;layer=mapnik&amp;marker=55.696260638940906%2C12.421760559082031"
    frameborder="0" height="470px" width="100%">
  </iframe>
</div>